import { render, staticRenderFns } from "./LuckGridItem.vue?vue&type=template&id=ebc90744&scoped=true"
import script from "./LuckGridItem.vue?vue&type=script&lang=js"
export * from "./LuckGridItem.vue?vue&type=script&lang=js"
import style0 from "./LuckGridItem.vue?vue&type=style&index=0&id=ebc90744&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebc90744",
  null
  
)

export default component.exports